import {
  useEffect,
  useState,
} from "react";

import CrudModal from "components/crud/CrudModal";
import CrudInput from "components/crud/CrudInput";
import CrudSelect from "components/crud/CrudSelect";

import {
  createOpeningBalance,
} from "services/api/collectionApi";

import {
  getSchools,
} from "services/api/schoolApi";

import {
  getParties,
} from "services/api/partyApi";

import {
  showSuccess,
  showError,
} from "utils/toast";


export default function OpeningBalanceModal({
  open,
  onClose,
  reload,
}) {

  const [
    loading,
    setLoading,
  ] = useState(false);

  const [
    schools,
    setSchools,
  ] = useState([]);

  const [
    parties,
    setParties,
  ] = useState([]);

  const [
    form,
    setForm,
  ] = useState({

    balanceType:
      "party",

    schoolId:
      "",

    partyId:
      "",

    amount:
      "",

    balanceDate:
      new Date()
        .toISOString()
        .substring(
          0,
          10
        ),

    remarks:
      "",

  });


  useEffect(() => {

    if (!open) {
      return;
    }

    loadDropdowns();

  }, [open]);


  const loadDropdowns =
    async () => {

      try {

        const [
          schoolResponse,
          partyResponse,
        ] = await Promise.all([

          getSchools(
            1,
            100,
            ""
          ),

          getParties(
            1,
            100,
            ""
          ),

        ]);

        setSchools(
          schoolResponse?.data?.schools ||
          []
        );

        setParties(
          partyResponse?.data?.parties ||
          []
        );

      } catch (error) {

        console.error(
          error
        );

      }

    };


  const updateField = (
    key,
    value
  ) => {

    setForm(
      (prev) => ({
        ...prev,
        [key]: value,
      })
    );

  };


  const submit = async (
    e
  ) => {

    e.preventDefault();


    if (
      !form.balanceDate
    ) {

      showError(
        "Balance date is required."
      );

      return;

    }


    if (
      !form.amount.trim()
    ) {

      showError(
        "Amount is required."
      );

      return;

    }


    if (
      form.balanceType === "school" &&
      !form.schoolId
    ) {

      showError(
        "Please select a school."
      );

      return;

    }


    if (
      form.balanceType === "party" &&
      !form.partyId
    ) {

      showError(
        "Please select a party."
      );

      return;

    }


    try {

      setLoading(
        true
      );


      await createOpeningBalance({

        balanceType:
          form.balanceType,

        schoolId:
          form.balanceType === "school"
            ? form.schoolId
            : undefined,

        partyId:
          form.balanceType === "party"
            ? form.partyId
            : undefined,

        amount:
          form.amount.trim(),

        balanceDate:
          form.balanceDate,

        remarks:
          form.remarks.trim() ||
          undefined,

      });


      showSuccess(
        "Opening balance created successfully. Outstanding balance has been initialized/updated."
      );


      await reload();

      onClose();

    } catch (error) {

      showError(
        error?.response?.data?.message ||
        "Unable to create opening balance."
      );

    } finally {

      setLoading(
        false
      );

    }

  };


  if (!open) {
    return null;
  }


  return (

    <CrudModal

      open={
        open
      }

      onClose={
        onClose
      }

      onSubmit={
        submit
      }

      loading={
        loading
      }

      title="Create Opening Balance"

      submitText="Create"

    >

      <CrudSelect
        label="Balance Type"
        value={
          form.balanceType
        }
        onChange={(e) => {

          updateField(
            "balanceType",
            e.target.value
          );

          updateField(
            "schoolId",
            ""
          );

          updateField(
            "partyId",
            ""
          );

        }}
        options={[
          {
            value:
              "party",
            label:
              "Party / Bookseller",
          },
          {
            value:
              "school",
            label:
              "School",
          },
        ]}
      />


      {
        form.balanceType ===
          "party" && (

          <CrudSelect

            label="Party"

            value={
              form.partyId
            }

            onChange={(e) =>
              updateField(
                "partyId",
                e.target.value
              )
            }

            options={[
              {
                value:
                  "",
                label:
                  "Select Party",
              },

              ...parties.map(
                (party) => ({
                  value:
                    String(
                      party.id
                    ),

                  label:
                    `${party.partyCode || ""} - ${party.name}`,
                })
              ),

            ]}

          />

        )
      }


      {
        form.balanceType ===
          "school" && (

          <CrudSelect

            label="School"

            value={
              form.schoolId
            }

            onChange={(e) =>
              updateField(
                "schoolId",
                e.target.value
              )
            }

            options={[
              {
                value:
                  "",
                label:
                  "Select School",
              },

              ...schools.map(
                (school) => ({
                  value:
                    String(
                      school.id
                    ),

                  label:
                    `${school.schoolCode || ""} - ${school.name}`,
                })
              ),

            ]}

          />

        )
      }


      <CrudInput
        label="Amount"
        type="number"
        min="0"
        step="0.01"
        value={
          form.amount
        }
        onChange={(e) =>
          updateField(
            "amount",
            e.target.value
          )
        }
      />


      <CrudInput
        label="Balance Date"
        type="date"
        value={
          form.balanceDate
        }
        onChange={(e) =>
          updateField(
            "balanceDate",
            e.target.value
          )
        }
      />


      <CrudInput
        label="Remarks"
        value={
          form.remarks
        }
        onChange={(e) =>
          updateField(
            "remarks",
            e.target.value
          )
        }
      />

    </CrudModal>

  );

}